import { render } from "./bulletins-index.vue?vue&type=template&id=13831fb7"
import script from "./bulletins-index.vue?vue&type=script&lang=js"
export * from "./bulletins-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__